import StyledSpinner from "../../styled/StyledSpinner";
import { useTranslation } from "react-i18next";

export const OcrModalWaitingScreen = () => {
  const { t } = useTranslation("boExpeditions");
  return (
    <dialog className="fixed top-0 left-0 z-50 flex h-full w-full items-center justify-center overflow-auto bg-[#00000080] backdrop-blur-sm">
      <div className="m-auto max-w-[90vw] rounded-lg bg-white lg:max-w-[1000px]">
        <div className="items- relative flex flex-col items-center justify-center gap-4 p-6">
          <StyledSpinner width="40" height="40" spinnerColor="text-brand700" />
          <h3 className="flex flex-row items-end gap-1">
            <span className="flex h-fit flex-row items-end gap-1 text-center align-baseline text-xl font-semibold text-black">
              {t("pendingShipmentsOcrModal.processingTitle")}
            </span>
          </h3>
          <p className="text-center text-sm font-medium text-gray-600">
            {t("pendingShipmentsOcrModal.processingDescription")}
          </p>
        </div>
      </div>
    </dialog>
  );
};
